export default __webpack_public_path__ + "media/images/ui-bg_flat_15_cd0a0a_40x100-09157b3a07628d31140ca21018c799f7.png";